import { nanoid } from "nanoid";
import { findStringBetweenMatchingBrace, getItemsFromString, getMatchesFromString, stripSqlCommentsAndEmptyLinesFromCode } from "../../helpers/parseHelpers";
import { firstMatch } from "../helpers/tsHelper";
import { IModelInfo, IModelMemberInfo } from "../ModelInfos/IModelInfo";


export function parseSql(data: string): IModelInfo[] {
    const code = stripSqlCommentsAndEmptyLinesFromCode(String(data));
    console.log("sql parse 1", code);
    const typesWithCode = getNamespacesAndTypesFromCode(code);

    const result: IModelInfo[] = [];
    for (const typeWithCode of typesWithCode) {
        console.log("sql parse 2", typeWithCode);
        const model = parseModelFromCode(typeWithCode);
        if (model) {
            result.push(model);
        }
    }

    console.log("sql parse 3", result);
    return result;
}

interface RelatedCode {
    typeKind: string;
    typeName: string;
    code: string;
    imports: string[];
}
function* getNamespacesAndTypesFromCode(code: string): Iterable<RelatedCode> {
    const reClass = /\b(create table)\s+?([^\s():]+)/gi;
    for (const match of getMatchesFromString(code, reClass)) {
        console.log("found", match);
        const [value, typeKind, typeName] = match;
        const start = match.index! + value.length - 1;
        const relatedCode = findStringBetweenMatchingBrace(code, start, "(", ")");

        let normalizedTypeName = replaceSqlQuotes(typeName).trim();
        normalizedTypeName = normalizedTypeName.split(".").pop()!;

        if (relatedCode && relatedCode.trim().length > 0) {
            yield {
                typeKind,
                typeName: normalizedTypeName,
                code: relatedCode,
                imports: []
            };
        }
    }
}

const replaceSqlQuotes = (str: string) => String(str).replace(/["'`[\]]/gm, "");
const sqlRangeChars = ['[', ']', '(', ')', '"', '`'];

function parseModelFromCode(typeWithCode: RelatedCode): IModelInfo | undefined {
    const { code, typeName, imports } = typeWithCode;

    const items = Array.from(getItemsFromString(code, [','], sqlRangeChars));
    const itemsWithAttr = items.map(x => ({ attrs: Array.from(getItemsFromString(x, [' ', '\r', '\n', '\t'], sqlRangeChars)).map(x => x.trim()).filter(x => x) }));

    //var lines = code.split(',');
    //const columns = /[^a-zA-Z\d\s:]?([_a-zA-Z0-9]+)[^a-zA-Z\d\s:]?\s+([_a-zA-Z0-9]+)([(]\d+[)])?/gm;
    //let props = lines.map(x => Array.from(getMatchesFromString(x, columns))[0]).filter(x => x);

    let props = itemsWithAttr.map(x => x.attrs.map(y => replaceSqlQuotes(y).trim()))
    console.log("props", props);

    const members: IModelMemberInfo[] = props.map(x => {
        let name = x[0];
        const typeName = x[1].replace(/\(.*\)/gm, "");
        const length = firstMatch(/\((\d+)\)/gm, x[1], "")[1];
        const hasNot = x.filter(y => y.toLowerCase().trim() === 'not').length > 0;
        const hasNull = x.filter(y => y.toLowerCase().trim() === 'null').length > 0;
        const nullable = hasNull && !hasNot;

        return {
            id: nanoid(),
            name: name,
            originalName: name,
            nullable: nullable,
            length: length !== undefined ? parseFloat(length.replace(/[^\d.]/gm, "")) : undefined,
            type: {
                name: typeName,
                originalName: typeName
            }
        };
    }).filter(x => x.name.toLowerCase() !== 'constraint');

    const model: IModelInfo = {
        id: nanoid(),
        importId: nanoid(),
        created: new Date(),
        namespace: "default",
        name: typeName,
        originalName: typeName,
        extends: [],
        imports,
        members
    };
    return model;
}
